// Enums
export enum StatusMaquina {
  DISPONIVEL = 'DISPONIVEL',
  IMPRIMINDO = 'IMPRIMINDO',
  MANUTENCAO = 'MANUTENCAO',
  INATIVA = 'INATIVA',
}

export enum OrigemPedido {
  SITE = 'SITE',
  MERCADOLIVRE = 'MERCADOLIVRE',
  SHOPEE = 'SHOPEE',
  MANUAL = 'MANUAL',
}

export enum StatusPedido {
  NOVO = 'NOVO',
  AGUARDANDO_PAGAMENTO = 'AGUARDANDO_PAGAMENTO',
  PAGO_CONFIRMADO = 'PAGO_CONFIRMADO',
  PRODUCAO = 'PRODUCAO',
  AGUARDANDO_SEPARACAO = 'AGUARDANDO_SEPARACAO',
  EM_SEPARACAO = 'EM_SEPARACAO',
  PRONTO_EXPEDICAO = 'PRONTO_EXPEDICAO',
  ENVIADO = 'ENVIADO',
  ENTREGUE = 'ENTREGUE',
  CANCELADO = 'CANCELADO',
}

export enum TipoPagamento {
  AVISTA = 'AVISTA',
  PARCELADO_50_50 = 'PARCELADO_50_50',
  BOLETO = 'BOLETO',
}

export enum UserRole {
  ADMIN = 'ADMIN',
  GERENTE = 'GERENTE',
  OPERADOR = 'OPERADOR',
  VENDEDOR = 'VENDEDOR',
}

export enum VisibilidadeProduto {
  CATALOGO = 'CATALOGO',
  SALA_SECRETA = 'SALA_SECRETA',
  AMBOS = 'AMBOS',
}

export enum TipoManufatura {
  PINTURA = 'PINTURA',
  LIXAMENTO = 'LIXAMENTO',
  REBARBA = 'REBARBA',
  MONTAGEM = 'MONTAGEM',
  COLAGEM = 'COLAGEM',
  POLIMENTO = 'POLIMENTO',
  IMPERMEABILIZACAO = 'IMPERMEABILIZACAO',
}

// Interfaces principais
export interface Maquina {
  id: string;
  nome: string;
  modelo: string;
  numeroSerie: string;
  valorAquisicao: number;
  depreciacaoMensal: number;
  custoHoraDepreciacao: number;
  status: StatusMaquina;
  horasUsoTotal: number;
  taxaRefugoHistorica: number;
  
  // Wi-Fi integration
  ipAddress?: string;
  apiKey?: string;
  printerType?: 'OCTOPRINT' | 'KLIPPER' | 'FLASHFORGE' | 'BAMBU' | 'PRUSA' | 'MARLIN';
  ultimoCheckpoint?: Date;
  realTimeStatus?: {
    status: string;
    progresso?: number;
    tempoRestante?: number;
    arquivo?: string;
    tempNozzle?: number;
    targetNozzle?: number;
    tempBed?: number;
    targetBed?: number;
  };

  createdAt: Date;
  updatedAt: Date;
}

export interface Filamento {
  id: string;
  material: 'PLA' | 'ABS' | 'PETG' | 'TPU' | 'ASA' | 'PC';
  cor: string;
  fabricante: string;
  pesoTotalComprado: number;
  pesoAtualGramas: number;
  custoPorKg: number;
  temperaturaNozzle: number;
  temperaturaMesa: number;
  dataCompra: Date;
}

export interface Embalagem {
  id: string;
  nome: string;
  tipo: string;
  dimensoes: string;
  custoUnitario: number;
  fornecedor: string;
  quantidadeEstoque: number;
}

export interface ProdutoFilamentoConfig {
  filamentoId: string;
  gramas: number;
  tipo: 'PECA' | 'SUPORTE' | 'DETALHE';
  filamento?: Filamento;
}

export interface FichaTecnica {
  filamentoId?: string;
  filamentos: ProdutoFilamentoConfig[];
  gramasFilamentoProduto: number;
  gramasFilamentoSuporte: number;
  tempoImpressaoMinutos: number;
  tempoPreparacaoMinutos: number;
  tempoManufaturaMinutos: number;
  maquinaPadraoId?: string;
  quantidadeLote: number;
  embalagens: { embalagemId: string; quantidade: number }[];
  tipoManufatura: TipoManufatura[];
  taxaRefugo: number;
  taxaDesperdicio: number;
}

export interface Categoria {
  id: string;
  nome: string;
  slug: string;
  descricao?: string;
  cor: string;
  ativo: boolean;
}

export interface Produto {
  id: string;
  nome: string;
  slug: string;
  skuInterno: string;
  descricao: string;
  descricaoML?: string;
  descricaoShopee?: string;
  modelo3D?: string;
  arquivo3DUrl?: string;
  nomeArquivo3D?: string;
  fotos: string[];
  videoTimelapseUrl?: string;
  videoTimelapseId?: string;
  categoriaId: string;
  categoria?: Categoria;
  filamento?: Filamento;
  altura?: number;
  largura?: number;
  comprimento?: number;
  pesoGramas?: number;
  
  // Ficha Técnica (dados brutos)
  filamentoId?: string;
  configuracaoFilamentos?: ProdutoFilamentoConfig[];
  gramasFilamentoProduto: number;
  gramasFilamentoSuporte: number;
  tempoImpressaoMinutos: number;
  tempoPreparacaoMinutos: number;
  tempoManufaturaMinutos: number;
  maquinaPadraoId?: string;
  quantidadeLote: number;
  embalagens: any; // JSON
  tipoManufatura: TipoManufatura[];
  taxaRefugo: number;
  taxaDesperdicio: number;
  
  // Precificação e Custos (calculados)
  markup: number;
  taxaImpostos: number;
  custoFilamento: number;
  custoEnergia: number;
  custoDepreciacao: number;
  custoEmbalagens: number;
  custoManufatura: number;
  custoTotalDireto: number;
  custoRealTotal: number;
  precoCustoCalculado: number;
  precoVendaSugerido: number;
  precoVenda: number;
  margemLucroPercent: number;
  lucroPorPeca: number;
  
  // Visibilidade
  visibilidade: VisibilidadeProduto;
  exclusivoSalaSecreta: boolean;
  
  estoqueDisponivel: number;
  estoqueMinimo: number;
  ativo: boolean;
  destaque: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface OrdemProducao {
  id: string;
  numeroOP: string;
  produtoId: string;
  produto?: Produto;
  maquinaId: string;
  maquina?: Maquina;
  quantidadeSolicitada: number;
  quantidadeBoa: number;
  quantidadeRefugada: number;
  status: StatusPedido;
  progressoPercentual: number;
  tempoRealMinutos: number;
  custoRealTotal?: number;
  dataInicio?: Date;
  dataFim?: Date;
  fotos?: string[];
  observacoes?: string;
  operadorId?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Cliente {
  id: string;
  nome: string;
  email: string;
  telefone?: string;
  cpfCnpj?: string;
  endereco?: string;
  cidade?: string;
  estado?: string;
  cep?: string;
  temAcessoSalaSecreta: boolean;
  asaasCustomerId?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface PedidoItem {
  id: string;
  produtoId: string;
  produto?: Produto;
  quantidade: number;
  precoUnitario: number;
  custoUnitarioReal: number;
}

export interface Pedido {
  id: string;
  numeroPedido: string;
  origem: OrigemPedido;
  clienteId: string;
  cliente?: Cliente;
  status: StatusPedido;
  tipoPagamento: TipoPagamento;
  pagamento1Status: 'PENDENTE' | 'PAGO' | 'CANCELADO';
  pagamento2Status?: 'PENDENTE' | 'PAGO' | 'CANCELADO';
  items: PedidoItem[];
  custoTotalReal: number;
  faturamentoTotal: number;
  lucroLiquidoCalculado: number;
  freteValor: number;
  freteModal: 'CORREIOS' | 'MOTOBOY' | 'RETIRADA';
  cupomCodigo?: string;
  descontoAplicado: number;
  
  // Logística
  melhorEnvioOrderId?: string;
  etiquetaUrl?: string;
  rastreioCodigo?: string;
  numeroNotaFiscal?: string;
  dataEtiqueta?: Date;
  dataEnvio?: Date;
  dataEntrega?: Date;

  createdAt: Date;
  updatedAt: Date;
}

export interface Cupom {
  id: string;
  codigo: string;
  tipo: 'PERCENTUAL' | 'VALOR_FIXO';
  valor: number;
  valorMinimo: number;
  descontoMaximo?: number;
  produtosElegiveis: string[];
  ativo: boolean;
  validoDe: Date;
  validoAte: Date;
  limiteUsos: number;
  usosAtuais: number;
}

export interface Usuario {
  id: string;
  nome: string;
  email: string;
  matricula?: string;
  role: UserRole;
  ativo: boolean;
  maquinasAutorizadas?: string[];
  twoFactorEnabled?: boolean;
  ultimoAcesso?: Date;
}

export interface CustoCalculado {
  produtoId: string;
  custoDireto: number;
  custoRealTotal: number;
  composicao: {
    filamentoProduto: number;
    filamentoSuporte: number;
    energia: number;
    depreciacao: number;
    embalagens: number;
    preparacao: number;
    manufatura: number;
  };
  custoLote: number;
  taxas: {
    refugo: number;
    desperdicio: number;
    valorRefugo: number;
    valorDesperdicio: number;
  };
  precificacao: {
    markup: number;
    taxaImpostos: number;
    precoVendaSugerido: number;
    lucroPorPeca: number;
    margemLucroPercent: number;
  };
  calculadoEm: Date;
}

export interface ConfigCusto {
  custoKwhAtual: number;
  custoHoraOperador: number;
  horasUteisMes: number;
  custosFixosMensais: number;
  taxaDesperdicioPadrao: number;
  margemMinimaPadrao: number;
}

// API Response types
export interface ApiResponse<T> {
  data: T;
  message?: string;
}

export interface ApiError {
  message: string;
  errors?: Array<{ field: string; message: string }>;
}
